export default __webpack_public_path__ + "static/media/webinar_thumb_04.d6293efb.jpg";